import React from "react";
import { Button, ButtonGroup, Col, Form } from "react-bootstrap";

import { defaultDateFormat } from "@lib/utils";

import { AdminControlsProps } from "@LeagueManagement/Organizations/types/organizations";

const AdminControls = ({
    methods,
    organization,
    isOrgApproved,
}: AdminControlsProps): React.JSX.Element => {
    return (
        <>
            <Form.Group controlId="approved" as={Col} md={3}>
                <Form.Label>Organization Teams Approved</Form.Label>
                <Form.Control
                    type="hidden"
                    {...methods.register("approved", {
                        value: isOrgApproved,
                    })}
                />
                <br />
                <ButtonGroup>
                    <Button
                        variant={isOrgApproved ? "primary" : "outline-primary"}
                        onClick={() => methods.setValue("approved", true)}
                    >
                        Yes
                    </Button>
                    <Button
                        variant={isOrgApproved ? "outline-primary" : "primary"}
                        onClick={() => methods.setValue("approved", false)}
                    >
                        No
                    </Button>
                </ButtonGroup>
            </Form.Group>
            <Col md={2}>
                <Form.Label>Approved By</Form.Label>
                <br />
                {organization?.approvedBy.name || "Not approved"}
            </Col>
            <Col md={2}>
                <Form.Label>Approved On</Form.Label>
                <br />
                {organization?.approvalDate
                    ? defaultDateFormat.format(
                          new Date(organization?.approvalDate),
                      )
                    : "Not approved"}
            </Col>
        </>
    );
};

export default AdminControls;
